<template>
    <div class="task-home" :style="{order:h5ConfigDetails[0]['modalOrder']['TaskHomeOrder'][0]}">
      <img class="bg" :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${h5ConfigDetails[0]['getDrawTimesPicture']['bg'][0]}`" alt="">

      <div class="task-wrapper" v-if="tasks && tasks.length !== 0">
        <div class="task-item" v-for="(task, idx) in tasks" :key="idx">
          <img class="task-bg" :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${task.bgImg}`" alt="">
          <img class="task-btn" :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${task.status === BTN_STATUS.TODO ? task.toDoBtnImg : (task.status === BTN_STATUS.TOGET ? task.getBtnImg : task.finishBtnImg)}`" 
            @click="_click_task_btn(task)" alt="">
          <div v-if="task.type == 4 && task.status === BTN_STATUS.TODO" class="task-times">已观看：{{ completedTimes }}/{{ allTimes }}</div>
        </div>
      </div>

    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import store from '@/store/index'
import { baseUrl } from '@/config/env'
import appBridge from '@/config/appBridge'
import { postTaskByTaskId } from '@/service/apis'
import { $isTimestampToday } from '@/util/util'

export default {
  name: 'TaskHome',
  props: ['loginFn'],
  data () {
    return {
      baseUrl,
      tasks: null,
      TASK_TYPE_MAP: {
        SHARE: '0', // 分享任务: 固定完成次数
        ACCEL: '1', // 加速任务：每日任务
        PAY: '2', // 购买任务：不限制
        FREE: '3', // 免费任务
        VIDEO: '4', // 激励视频任务
        LIVELINK: '5' // livelink任务
      },
      BTN_STATUS: Object.freeze({
        TODO: 'todo', // 去完成
        TOGET: 'toget', // 立即领取 （加速礼包在检测到替身礼包后需要用户手动完成任务，再给盲盒主礼包）
        FINISH: 'finish' // 已完成
      }),
      completedTimes: 0,
      allTimes: 0
    }
  },
  mounted () {
    this._bind_custom_events()
    this._create_coupons()
  },
  methods: {
    _bind_custom_events () {
      window.eventBus.$on('onTaskResult', async (isSuccess, taskId) => {
        // 分享失败情况
        if (!isSuccess) {
          this.$toast('任务失败，请稍后重试')
          return
        }

        this._do_task(taskId)
      })
    },
    async _do_task (taskId) {
      try {
          const res = await postTaskByTaskId(this.userInfo.userId, taskId)
  
          // 分享成功后任务完成失败情况
          if (res.resultCode !== 0) {
            this.$toast('任务完成失败，请稍后重试！')
            return
          }
  
          window.eventBus.$emit('refreshAfterPay')
          this.$toast('恭喜获得抽奖机会！')
        } catch (error) {
          this.$toast('任务完成失败，请稍后重试！')
        }
    },
    _create_coupons () {
      // console.log(this.h5ConfigDetails[0])
      const data = this.h5ConfigDetails[0].getDrawTimesCoupon
      this.tasks = data['bg'].map((ele, idx) => {
        const taskId = data['taskId'][idx].indexOf(';') !== -1 ? (this.isInIos ? data['taskId'][idx].split(';')[1] : data['taskId'][idx].split(';')[0]) : data['taskId'][idx]
        const type = data['taskType'][idx]
        const finishBtnImg = data['finishBtn'][idx]
        const toDoBtnImg = data['toDoBtn'][idx]
        const getBtnImg = data['getBtn'][idx]
        const videoCouponId = data['videoCouponId'] ? data['videoCouponId'][0] : ''

        return {
          taskId,
          finishBtnImg,
          toDoBtnImg,
          getBtnImg,
          bgImg: ele, // 每条的img config
          type,
          videoCouponId,
          status: this._calc_btn_status(type, taskId, videoCouponId), // 礼包状态
        }
      })
    },
    _calc_btn_status(type, taskId, videoCouponId) {
      let status

      const task = this.taskList ? this.taskList.find((task) => {
        return task.taskId === taskId
      }) : null
      switch (type) {
        case this.TASK_TYPE_MAP.SHARE:
          // 临时补丁，解决导航栏分享不触发下方分享任务的问题
          if (task && task.completedTimes < task.allTimes) {
            store.commit('SET_SHARE_TASK_ID', task.taskId)
          }

          status = task ? (task.completedTimes < task.allTimes ? this.BTN_STATUS.TODO : this.BTN_STATUS.FINISH) : this.BTN_STATUS.TODO
          break
        case this.TASK_TYPE_MAP.ACCEL:
          status = task ? (task.completedTimes < task.allTimes ? this.BTN_STATUS.TODO : this.BTN_STATUS.FINISH) : this.BTN_STATUS.TODO
          break
        case this.TASK_TYPE_MAP.PAY:
          status = this.BTN_STATUS.TODO
          break
        case this.TASK_TYPE_MAP.VIDEO:
          if(task){
            this.completedTimes = task.taskProgress.length % Math.min(...Object.keys(task.checkPoints))
            this.allTimes = Math.min(...Object.keys(task.checkPoints))
          } else {
            status = this.BTN_STATUS.TODO
          }
          if(task && (task.taskProgress.length < Math.max(...Object.keys(task.checkPoints)))) {
            status = this.BTN_STATUS.TODO
          } else {
            status = this.BTN_STATUS.FINISH
            console.log(videoCouponId)
            // const isReceived = this.couponsHistory ? this.couponsHistory.exchangeHistoryList.find((his) => {
            //   return his.couponId === videoCouponId
            // }) : null
            // if (isReceived){
            //   status = this.BTN_STATUS.FINISH
            // }
          }
          break
        case this.TASK_TYPE_MAP.LIVELINK:
          if (task && task.taskType == '2' && task.checkType == 1) { // 周期累计任务
            if (task.taskProgress.length === 0) {
              status = this.BTN_STATUS.TODO
              break
            }

            task.taskProgress.sort((a, b) => {
              return Number(a.timestamp) - Number(b.timestamp)
            })

            status = task.taskProgress.length == task.allTimes ? this.BTN_STATUS.FINISH : ($isTimestampToday(task.taskProgress[task.taskProgress.length-1].timestamp) ? this.BTN_STATUS.FINISH : this.BTN_STATUS.TODO)
          } else { // 老业务
            status = task ? (task.completedTimes < task.allTimes ? this.BTN_STATUS.TODO : this.BTN_STATUS.FINISH) : this.BTN_STATUS.TODO
          }
          break
        case this.TASK_TYPE_MAP.FREE: 
          status = task ? (task.completedTimes < task.allTimes ? this.BTN_STATUS.TODO : this.BTN_STATUS.FINISH) : this.BTN_STATUS.TODO
          break
        default:
          status = this.BTN_STATUS.FINISH
      }

      return status
    },
    _click_task_btn (task) {
      if (!this.isLogin) {
        return this.loginFn()
      }

      if (this.llkSwitchOn && !this.isBinded) {
        this.$toast('请先绑定游戏账号', 3000)
        return
      }

      // 已完成过的任务不必再完成
      if (task.status === this.BTN_STATUS.FINISH) {
        return
      }

      const activitySetting = this.h5ConfigDetails[0].activitySetting
      switch (task.type) {
        case this.TASK_TYPE_MAP.SHARE:
          this.$sensors.track('app_page_click', {module_name: 'draw_chance', click_result: 'share'})
          // postTaskByTaskId(this.userInfo.userId, '9d37b2c0-a188-4d58-b2ce-cbd12822b128')
          appBridge.shareByApp(activitySetting.shareTitle[0], activitySetting.shareContent[0], activitySetting.shareIcon[0], window.location.href)
          break
        case this.TASK_TYPE_MAP.ACCEL:
          this.$sensors.track('app_page_click', {module_name: 'draw_chance', click_result: 'accelerate'})

          // if (task.status === this.BTN_STATUS.TOGET) {
          //   window.eventBus.$emit('onTaskResult', true, task.taskId)
          //   return
          // }
          if (!appBridge.isInstallGame(activitySetting.packageNameAndroid[0])) {
            this.$toast('请先安装该游戏')
            return
          }
          
          // 调起app加速接口
          // appBridge.startAcc(this.isInIos ? getDrawTimesText.gameUidIOS[0] : getDrawTimesText.gameUidAndroid[0])
          appBridge.finishTask(task.taskId, 17)
          break
        case this.TASK_TYPE_MAP.PAY:
          this.$sensors.track('app_page_click', {module_name: 'draw_chance', click_result: 'buy_vip'})

          // postTaskByTaskId(this.userInfo.userId, '5728804c-9916-444f-b2a9-97a0531cd4ad')
          // 调起内部支付弹窗
          this.$parent.$refs.payPanelBottom.show()
          break
        case this.TASK_TYPE_MAP.VIDEO:
          this.$sensors.track('app_page_click', {module_name: 'draw_chance', click_result: 'watch'})
          appBridge.finishTask(task.taskId, 22)
          break
        case this.TASK_TYPE_MAP.LIVELINK:
          this._process_livelink_task(task)
          break
        case this.TASK_TYPE_MAP.FREE:
          if(new Date(this.userInfo.vipExpiredTimeStr).getTime() > this.activityConfig.startTime) {
            this._do_task(task.taskId)
          } else {
            this.$toast('您的会员已过期', 3000)
          }
          break
        default:
      }
    },
    // 点击livelink登录任务得处理流程
    async _process_livelink_task (task) {
      let taskRes

      try {
        taskRes = await postTaskByTaskId(this.userInfo.userId, task.taskId, {accumulativeValue: 1})
        if (taskRes.resultCode === 0) {
          window.eventBus.$emit('refreshAfterPay')
          this.$toast('任务已完成', 3000)
          this.$sensors.track('app_page_click', {module_name: 'draw_chance', button_name: 'log_misson', click_result: 'success'})

          // task.status = this.BTN_STATUS.FINISH
        } else {
          this.$toast('请您登录游戏后领取', 3000)
          this.$sensors.track('app_page_click', {module_name: 'draw_chance', button_name: 'log_misson', click_result: 'fail'})
        }
      } catch (error) {
        this.$sensors.track('app_page_click', {module_name: 'draw_chance', button_name: 'log_misson', click_result: 'fail'})

        // 实际接口未登录返回是这样的
        if (error.error && error.error.indexOf('error code: 0') >= 0) {
          this.$toast('请您登录游戏后领取', 3000)
          return
        }

        // if (error.error && error.error.indexOf('the accumulative value is invalid') >= 0) {
        //   this.$toast('领取次数已满', 3000)
        //   return
        // }

        this.$toast('任务领取失败，请稍后重试', 3000)
      }
    }
  },
  computed: {
    ...mapState(['h5ConfigDetails', 'h5ConfigImgPath', 'userInfo', 'isInIos', 'taskList', 'couponsHistory', 'isLogin', 'couponList', 'llkSwitchOn', 'activityConfig']),
    ...mapGetters([
      'isBinded'
    ])
  },
  watch: {
    taskList () {
      this._create_coupons()
    }
  }
}
</script>

<style scoped lang="less">
  .task-home {
    position: relative;    
    font-size: 0;
  }

  .bg {
    width: 100%;
    height: auto;
    display: block;
  }

  .task-item {
    width: 100%;
    position: relative;
    font-size: 0;
    margin-bottom: 1.2rem;
  }

  .task-bg {
    width: 100%;
  }

  .task-btn {
    width: 9rem;
    position: absolute;
    right: 3rem;
    top: 0;
    bottom: 0;
    margin: auto 0;
  }

  .task-times {
    width: 9rem;
    position: absolute;
    right: 3rem;
    top: 6rem;
    font-size: 1rem;
    color: #fff;
    text-align: center;
  }

  .task-wrapper {
    position: absolute;
    top: 0;
    right: 0;
    padding-top: 6rem;
    // height: calc(100% - 4.1rem);
    // display: flex;
    // flex-direction: column;
    // align-items: center;
    // justify-content: space-around;
  }
</style>
